import store from 'redux/store';
export default class Tool {
  // 节流
  static throttle(fn, delay) {
    let timer = null;
    let starTime = new Date();
    return () => {
      let curTime = new Date();
      clearInterval(timer);
      // 规定的时间触发，不然用户一直操作就一直不会触发
      if (curTime - starTime >= delay) {
        starTime = curTime;
        fn();
      } else {
        timer = setTimeout(fn, delay);
      }
    };
  }

  // 防抖
  static debounce(func, delay) {
    // let timer = null;
    // return () => {
    //   clearInterval(timer);
    //   timer = setTimeout(fn, delay);
    // };
    let timeout;
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        func();
      }, delay);
    };
  }

  // 处理路由路径
  static processingPath(list, parentPath) {
    list.forEach((item) => {
      parentPath && (item.path = parentPath + '/' + item.path);
      if (item.children && item.children.length > 0) {
        this.processingPath(item.children, item.path);
      }
    });
    return list;
  }

  // 路由转map对象
  static routesToMap(asyncRoutes, routesMap = {}) {
    // console.log("asyncRoutes", asyncRoutes);

    asyncRoutes.forEach((item) => {
      let temp = { ...item };
      if (item.subMenu && item.subMenu.length > 0) {
        delete temp.subMenu;
        routesMap[item.path] = temp;
        this.routesToMap(item.subMenu, routesMap);
      } else {
        routesMap[item.path] = temp;
      }
    });
    // console.log("asyncRoutes", routesMap);
    return routesMap;
  }

  // 后缀名
  static extension(str) {
    return str.substring(str.lastIndexOf('.') + 1);
  }

  // 提取金额最多2个小数
  static getAmount(digitalStr) {
    return digitalStr.replace(/^\D*([1-9]\d*\.?\d{1,2})?.*$/, '$1');
  }

  // 获取上一个月时间
  static getPreMonth(date) {
    var d = new Date(date);
    d.setMonth(d.getMonth() - 1);
    return d;
  }

  // 流文件下载
  static fileDdownload(data) {
    let blob = new Blob([data], {
      type: 'application/vnd.ms-excel;charset=UTF-8',
    });
    let url = window.URL.createObjectURL(blob);
    let aLink = document.createElement('a');
    aLink.style.display = 'none';
    aLink.href = url;
    aLink.setAttribute('download', 'filename');
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
    window.URL.revokeObjectURL(url);
  }
  // form文件下载
  static fileDdownloada(url) {
    var dlform = document.createElement('form');
    dlform.style = 'display:none;';
    dlform.method = 'post';
    dlform.action = url;
    dlform.target = 'callBackTarget';
    var hdnFilePath = document.createElement('input');
    hdnFilePath.type = 'hidden';
    hdnFilePath.name = 'filePath';
    hdnFilePath.value = 'filename';
    dlform.appendChild(hdnFilePath);
    document.body.appendChild(dlform);
    dlform.submit();
    document.body.removeChild(dlform);
  }

  // 判断浏览器agent
  static isMobile() {
    const userAgentInfo = navigator.userAgent;
    const mobileAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = false;
    mobileAgents.forEach((v) => {
      if (userAgentInfo.includes(v)) flag = true;
    });
    return flag;
  }
  //解析url
  static getRequest(search) {
    const theRequest = new Object();
    const index = search.lastIndexOf('?');
    if (index != -1) {
      let str = search.substr(index + 1);
      str = str.split('&');
      for (var i = 0; i < str.length; i++) {
        theRequest[str[i].split('=')[0]] = decodeURI(str[i].split('=')[1]);
      }
    }
    return theRequest;
  }
  /**
   * 功能：上拉加载(防抖)
   * 原理：当向上卷去的高度+容器的高度>= 内容的高度，说明拉到最低，可加载下一页
   */
  static loadMore(element, callback) {
    function _loadMore() {
      let containerHeight = element.clientHeight; // 容器高度
      let scrollTop = element.scrollTop; // 卷上去的高度
      let scrollHeight = element.scrollHeight; // 内容的高度
      if (scrollTop + containerHeight + 20 >= scrollHeight) {
        console.log('store.getState().hasMore', store.getState().hasMore)
        if (store.getState().hasMore) {
          callback && callback();
        }
      }
    }
    element.addEventListener('scroll', this.debounce(_loadMore, 600), false);
  }
  /**
   * 功能：下拉刷新(节流)
   * 原理：根据offsetTop
   */
  static downRefresh(element, callback) {
    let startY = null; //变量 存储接下来时候的纵坐标
    let distance = null; // 本次下拉的距离
    let originalTop = element.offsetTop; // 最初此元素距离顶部的距离
    let _timer;
    let currentTop;
    // let that = this;
    element.addEventListener('touchstart', function (event) {
      if (_timer) { // 如果重新开始touchstart，则要把上一次的回弹定时器清楚
        clearInterval(_timer);
      }
      // let touchmove = that.throttle(_touchmove, 60); // 节流
      // 只有当元素处于原始位置才能下拉，如果处于回弹的时候并且此元素向上卷去的高度=0 就不能下拉
      if (element.scrollTop === originalTop && element.scrollTop === 0) {
        console.log('event', event.targetTouches[0])
        currentTop = element.offsetTop;
        startY = event.targetTouches[0].pageY;// 记录当前点击的纵坐标
        element.addEventListener('touchmove', _touchmove)
        element.addEventListener('touchend', _touchend)
      }
      function _touchmove(event) {
        let payeY = event.targetTouches[0].pageY; // 拿到最新的坐标
        if (payeY > startY) {
          distance = payeY - startY;
          element.style.top = currentTop + distance + 'px';
        } else {
          element.removeEventListener('touchmove', _touchmove)
          element.removeEventListener('touchend', _touchend)
        }

      }
      function _touchend(event) {
        element.removeEventListener('touchmove', _touchmove)
        // element.removeEventListener('touchend', _touchend)
        // 下拉的页面回弹
        _timer = setInterval(() => {
          let currentTop = element.offsetTop;
          if (currentTop - originalTop > 1) {
            element.style.top = (currentTop - 1) + 'px';
          } else {
            element.style.top = originalTop + 'px'
          }
        }, 13);
        if (distance > 30) {
          callback();
        }
      }
    });
  }
  // base64转文件流
  static base64toFile(dataurl, filename = 'file') {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let suffix = mime.split('/')[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, {
      type: mime
    })
  }
}
